module.exports = __webpack_public_path__ + "img/deal.127c56a6.svg";